<template>
    <b-form-group :label="label" label-for="select-user">
        <select-with-avatar
            id="select-user"
            :state="state"
            :options="usersOptions"
            :selected="value"
            :aria-describedby="ariaDescribedByComputed"
            :placeholder="placeholder"
            :close-on-select="true"
            :internal-search="false"
            :loading="loading"
            :no-elements-found="$t('form.multiselect.noUserWasFound')"
            :clear-on-select="false"
            :next-page-button="nextPageButton"
            :disabled="disabled"
            :multiple="multiple"
            :allowEmpty="allowEmpty"
            @changeSearch="debouncedSearchHandler"
            @nextPage="nextPage"
            @changeValue="$emit('update:value', $event)"
            :showLabels="showLabels"
            :hideSelected="hideSelected"
        />
        <b-form-invalid-feedback id="evaluatedId">
            <slot name="validations" />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import SelectWithAvatar from '@/views/components/selects/select-with-avatar'
import { mapperToOptions as mapperToUsers } from '@/views/components/selects/select-with-avatar'
import { uniqBy, debounce } from 'lodash'
import api from '@/services/api'
import { getUserData } from '@/services/user-data'

export default {
    name: 'Users',
    components: {
        SelectWithAvatar,
    },
    props: {
        value: {},
        state: {},
        disabled: {},
        label: {},
        placeholder: {
            type: String,
            default: () => i18n.t('form.placeholder.select'),
        },
        multiple: {},
        ariaDescribedby: {},
        allowEmpty: {},
        alreadySelectedUserId: null,
        showLabels: {},
        hideSelected: {},
    },
    data() {
        return {
            usersReady: false,
            usersOptions: [],
            showErrorMessage: false,
            loading: false,
            paginaton: {
                page: 1,
                lastPage: 1,
                perPage: 50,
            },
            search: null,
            oldSearch: null,
            model: null,
        }
    },
    created() {
        this.debouncedSearchHandler = debounce(this.searchUserByName, 1000)
    },
    mounted() {
        this.loadUsers()
    },
    methods: {
        loadUsers() {
            let userId

            if (this.alreadySelectedUserId) {
                userId = this.alreadySelectedUserId
            } else {
                const { id } = getUserData()
                userId = id
            }

            if (this.value && this.value.length > 0) {
                const userSelected = this.value.map((user) => {
                    return {
                        value: user.value,
                        label: user.label || '',
                        picture: user.picture || '',
                        occupation: user.occupation || '',
                    }
                })
                this.$emit('already-selected-user', userSelected)
            }

            api.get(`/users/${userId}`, {
                params: {
                    filter: 'id;name;occupation;picture;manager_id',
                    with: 'subordinates;manager',
                },
            }).then((resp) => {
                const user = resp.data.data

                if (this.alreadySelectedUserId && !this.value) {
                    const alreadySelectedUser = mapperToUsers([user])[0]
                    this.$emit('already-selected-user', alreadySelectedUser)
                }

                const subordinates = user.subordinates ? user.subordinates : []
                const manager = user.manager ? [user.manager] : []

                let defaultUsers = subordinates.concat(manager).concat([resp.data.data])
                defaultUsers = uniqBy(defaultUsers, 'id')
                this.usersOptions = mapperToUsers(defaultUsers)
            })
        },
        searchUserByName(search) {
            this.search = search
            if (search) {
                this.loading = true

                //Se for a primeira paginação
                if (this.oldSearch != this.search) {
                    this.usersOptions = []
                    this.resetPagination()
                }
                const params = {
                    orderBy: 'name',
                    filter: 'id;name;occupation;picture',
                    search: `name:${search.trim() || ''}`,
                    searchFields: 'name:like',
                    and: 'yes',
                    per_page: this.paginaton.perPage,
                    page: this.paginaton.page,
                }

                api.get('/users', { params }).then((resp) => {
                    const {
                        data: { data },
                    } = resp
                    if (data.current_page > 1) {
                        this.usersOptions = this.usersOptions.concat(mapperToUsers(data.data))
                    } else {
                        this.usersOptions = mapperToUsers(data.data)
                    }
                    this.paginaton.lastPage = data.last_page
                    this.loading = false
                    this.oldSearch = search
                })
            } else {
                this.loadUsers()
            }
        },
        resetPagination() {
            this.paginaton.page = 1
            this.paginaton.lastPage = 1
        },
        nextPage() {
            this.paginaton.page++
            this.searchUserByName(this.search)
        },
    },
    computed: {
        nextPageButton() {
            return {
                isShowNextPage: this.paginaton.lastPage > 1,
                isLastPage: this.paginaton.page == this.paginaton.lastPage,
                loading: this.loading,
            }
        },
        ariaDescribedByComputed() {
            return this.ariaDescribedby || 'evaluatedId'
        },
    },
}
</script>
